export const ModalHeader = (data) => {
  return (
    <div className="d-flex justify-content-between align-items-center">
      <i className="icon-window-filled modal-close-icon pointer F-size14" onClick={data?.onHide} />
      <span className="F-size14">{data?.title || ''}</span>
      <span style={{ width: '17px' }}></span>
    </div>
  );
};
